import { buildQueryKey } from '@webapp/core/utils/react-query/buildQueryKey'
import {
  approverRepository,
  type RequestableApproverParams,
} from '../data-access/repositories/ApproverRepository'

const base = ['expense-requestable-approver']

export const approverQueryConfig = {
  requestableApprovers: (params: RequestableApproverParams) => ({
    queryKey: buildQueryKey([...base, 'requestable', params]),
    queryFn: () => approverRepository.listRequestableApprovers(params),
  }),
}
